.container {
    padding: 8px;
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.container--error {
    background-color: var(--rose-xlt);
}

.container--success {
    background-color: var(--warning-bg);
}
